<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="toc"></a><a id="page_ix"><img alt="Images" src="images/common.jpg"/> Contents <img alt="Images" src="images/common.jpg"/></a></h2><a id="page_ix">
</a><p class="toc1"><a id="page_ix"></a><a href="#/xhtml/map">Map of the Candy Kingdom</a></p>
<p class="toc"><a href="#/xhtml/ch01"><span class="smallcaps"><span class="txbf">CHAPTER 1</span></span> Lost Gummy Flavors</a></p>
<p class="toc"><span href="#/xhtml/ch02" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 2</span></span> Tropical Treasure</span></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 3</span></span> Quicksand Trouble</span></p>
<p class="toc"><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 4</span></span> Mystery of Gummy Lagoon</span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 5</span></span> Hagoo’s Surprise</span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 6</span></span> Gum-Gum Magic</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 7</span></span> Special Treats</span></p>
<p class="toc"><span href="#/xhtml/ch08" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 8</span></span> Gummy Secrets</span></p>
<p class="toc"><span href="#/xhtml/ch09" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 9</span></span> Tropical Burst</span></p>
<p class="toc1"><span href="#/xhtml/ch10" title="Link target outside of Sample"><span class="smallcaps"><span class="txbf">CHAPTER 10</span></span> Sweet Endings</span></p>
<p class="toc"><span href="#/xhtml/treasure" title="Link target outside of Sample"><span class="txit">Rock Candy Treasure</span> Excerpt</span></p>
<p class="toce"><span href="#/xhtml/authorbio" title="Link target outside of Sample">About Helen Perelman</span><a id="page_x"></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?e53eef78